<template>
  <div :class="['post-card', { pinned: post.is_pinned }]">
    <!-- بج پین -->
    <div v-if="post.is_pinned" class="pin-badge">📌</div>

    <!-- بج نوع -->
    <div :class="['type-badge', post.type]">
      {{ typeLabel }}
    </div>

    <!-- پیش‌نمایش -->
    <div class="post-preview" @click="$emit('detail', post)">
      <img
          v-if="post.type === 'single' && post.media.length > 0"
          :src="post.media[0].url"
          class="preview-img"
          alt="نمونه کار"
      />

      <div v-else-if="post.type === 'before_after' && post.media.length >= 2" class="before-after">
        <div class="ba-item">
          <img :src="post.media[0].url" alt="قبل" />
          <span class="ba-label before">قبل</span>
        </div>
        <div class="ba-item">
          <img :src="post.media[1].url" alt="بعد" />
          <span class="ba-label after">بعد</span>
        </div>
      </div>

      <div v-else-if="post.type === 'slide' && post.media.length > 0" class="slide-preview">
        <img :src="post.media[0].url" class="preview-img" alt="اسلاید" />
        <div v-if="post.media.length > 1" class="slide-count">
          🖼 {{ post.media.length }} عکس
        </div>
      </div>

      <div v-else class="no-image">بدون عکس</div>
    </div>

    <!-- محتوا -->
    <div class="post-content">
      <p v-if="post.caption" class="post-caption">{{ post.caption }}</p>
      <p v-else class="post-caption no-caption">بدون کپشن</p>

      <div v-if="post.lines.length > 0" class="post-lines">
        <span v-for="line in post.lines" :key="line.id" class="line-tag">
          {{ line.title }}
        </span>
      </div>

      <div class="post-meta">
        <span class="post-date">{{ get_date(post.created_at) }}</span>
      </div>
    </div>

    <!-- عملیات -->
    <div class="post-actions">
      <button class="btn-action btn-pin" @click="$emit('pin', post)" :title="post.is_pinned ? 'آنپین' : 'پین'">
        {{ post.is_pinned ? '📌' : '📍' }}
      </button>
      <button class="btn-action btn-edit" @click="$emit('edit', post)" title="ویرایش">
        ✏️
      </button>
      <button class="btn-action btn-delete" @click="$emit('delete', post)" title="حذف">
        🗑️
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostCard',

  props: {
    post: {
      type: Object,
      required: true
    }
  },

  computed: {
    typeLabel: function() {
      var map = {
        single: '🖼 تکی',
        before_after: '↔️ قبل/بعد',
        slide: '🎠 اسلایدی'
      };
      return map[this.post.type] || this.post.type;
    }
  },

  methods: {

  }
};
</script>

<style scoped>
.post-card {
  position: relative;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
}

.post-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.post-card.pinned {
  border: 2px solid #409eff;
}

.pin-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #409eff;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
}

.type-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  z-index: 2;
  background: rgba(255, 255, 255, 0.95);
  color: #2c3e50;
}

.type-badge.single { color: #409eff; }
.type-badge.before_after { color: #e6a23c; }
.type-badge.slide { color: #67c23a; }

.post-preview {
  position: relative;
  width: 100%;
  height: 280px;
  background: #f5f7fa;
  cursor: pointer;
  overflow: hidden;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.before-after {
  display: flex;
  width: 100%;
  height: 100%;
}

.ba-item {
  position: relative;
  flex: 1;
  overflow: hidden;
}

.ba-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ba-label {
  position: absolute;
  bottom: 8px;
  right: 8px;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  color: white;
}

.ba-label.before { background: rgba(230, 162, 60, 0.9); }
.ba-label.after { background: rgba(103, 194, 58, 0.9); }

.slide-count {
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #c0c4cc;
  font-size: 14px;
}

.post-content {
  padding: 14px 16px;
}

.post-caption {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #303133;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.post-caption.no-caption {
  color: #c0c4cc;
  font-style: italic;
}

.post-lines {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.line-tag {
  padding: 2px 10px;
  background: #f0f9eb;
  color: #67c23a;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.post-meta {
  font-size: 11px;
  color: #909399;
}

.post-actions {
  display: flex;
  border-top: 1px solid #f0f0f0;
}

.btn-action {
  flex: 1;
  padding: 10px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.2s;
}

.btn-action:hover { background: #f5f7fa; }
.btn-pin:hover { background: #ecf5ff; }
.btn-edit:hover { background: #fdf6ec; }
.btn-delete:hover { background: #fef0f0; }
</style>